export interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

const HomepageBannerCTAValues = {
    control: 'search',
    base: 'city_browse',
};

export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'banner_cta_opens_search_screen',
    paramName: 'banner_cta_destination',
    values: HomepageBannerCTAValues,
};

export enum SearchMapSmokeTestExperimentValues {
    control = 'control',
    variantA = 'variantA',
    variantB = 'variantB',
}

export const SearchMapSmokeTestExperiment: Experiment<
    typeof SearchMapSmokeTestExperimentValues
> = {
    name: 'map_smoke_test_2_mobile_web',
    paramName: 'smoke_map_type',
    values: SearchMapSmokeTestExperimentValues,
};

/**
 * Leave the names of the enums/configs/etc static to keep imports from
 * needing to change as we iterate.
 *
 * Update the values to represent the new focus/paramname/goal of the test.
 * At the moment these correlate to the card map exported from DiscoverEventCard.
 */
export enum SearchCardFullClickExperimentValues {
    control = 'control',
    fullClick = 'fullClick',
}

export const SearchCardFullClickExperiment: Experiment<
    typeof SearchCardFullClickExperimentValues
> = {
    name: 'search_event_card_full_click_client',
    paramName: 'search_card_type',
    values: SearchCardFullClickExperimentValues,
};

export const SearchBoxAndLocationPillValues = {
    control: 'appears',
    base: 'does_not_appear',
};

export const EventCategoryCarouselValues = {
    control: 'all_events',
    base: 'horizontal_carousels',
};

export const EventCategoryCarouselExperiment: Experiment<
    typeof EventCategoryCarouselValues
> = {
    name: 'homepage_event_category_carousels',
    paramName: 'homepage_events_view',
    values: EventCategoryCarouselValues,
};

export enum BrowseCardHierarchyExperimentValues {
    control = 'control',
    hierarchy = 'hierarchy',
}

export const BrowseCardHierarchyExperiment: Experiment<
    typeof BrowseCardHierarchyExperimentValues
> = {
    name: 'browse_card_1',
    paramName: 'browse_card_type',
    values: BrowseCardHierarchyExperimentValues,
};

// TODO: EB-225864 sticky experiment cleanup
export enum StickyExperimentValues {
    control = 'control',
    sticky = 'sticky',
}

export const StickyExperiment: Experiment<typeof StickyExperimentValues> = {
    name: 'sticky_header_nav',
    paramName: 'navigation_style',
    values: StickyExperimentValues,
};

export enum SubCategoryExperimentValues {
    control = 'control',
    subCategories = 'subcategories',
}

export const SubCategoryExperiment: Experiment<
    typeof SubCategoryExperimentValues
> = {
    name: 'search_subcategory_filters',
    paramName: 'category_type',
    values: SubCategoryExperimentValues,
};

export enum UrgencySignalEventCardExperimentValues {
    control = 'control',
    variantA = 'varianta',
    variantB = 'variantb',
}

export const UrgencySignalEventCardExperiment: Experiment<
    typeof UrgencySignalEventCardExperimentValues
> = {
    name: 'urgency_signal_web_search',
    paramName: 'urgency_signal_type',
    values: UrgencySignalEventCardExperimentValues,
};

export enum EventCardImageExperimentValues {
    control = 'control',
    multi = 'multi',
}

export const EventCardImageExperiment: Experiment<
    typeof EventCardImageExperimentValues
> = {
    name: 'search_multiple_image_promoted_events',
    paramName: 'image',
    values: EventCardImageExperimentValues,
};
